import { IvTrackType } from '../enums'

export const trackHeightMap: Record<IvTrackType, number> = {
  [IvTrackType.Audio]: 64,
  [IvTrackType.Video]: 64,
  [IvTrackType.Hand]: 32,
  [IvTrackType.Image]: 32,
  [IvTrackType.Text]: 32,
  [IvTrackType.Iv]: 32,
}
